import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class InventoryGoodsReceiptItemCannotBeOneTimeUsage extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.inventory.goods-receipt.validation.item.cannot-be-one-time-usage');
    }
}
